/**
 * useTheme — resolves the active color mode once.
 *
 * Usage:
 *   const { colors, isDark, mode } = useTheme();
 *
 * No component should ever call useConfigStore() + getThemeColors() directly.
 */

import { useConfigStore } from '@share/core';
import { getThemeColors, ThemeColors, ColorMode } from '../theme/tokens';

export interface ThemeResult {
  mode:   ColorMode;
  isDark: boolean;
  colors: ThemeColors;
}

export const useTheme = (): ThemeResult => {
  const { config } = useConfigStore();
  const mode: ColorMode = config.theme === 'system' ? 'dark' : config.theme as ColorMode;
  return {
    mode,
    isDark: mode === 'dark',
    colors: getThemeColors(mode),
  };
};
